import { useNavigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ApplyTemplateModal from 'modules/surveys/components/Questions/ApplyTemplateModal'

const ApplyQuestionsTemplatePage = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()
  const { question_group_config_id, id } = useParams()

  const onClose = () =>
    navigate(navigation.processes.surveys.id.questions.fullPath({ id: String(id) }))

  return (
    <ApplyTemplateModal
      surveyId={id ?? ''}
      onClose={onClose}
      questionGroupConfigId={question_group_config_id ?? ''}
    />
  )
}

export default ApplyQuestionsTemplatePage
